export default __webpack_public_path__ + "static/media/tecnico.cb1b850a.png";